import React, { useState, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import "./PartnerBillDetails.css";
import cancel from "../../../../assests/cancel.svg";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import leftArrow from "../../../../assests/leftArrow.svg";
import billsummery from "../../../../assests/billsummery.svg";
import chargeicon from "../../../../assests/chargeicon.svg";

const PartnerBillDetailsComponent = ({
  loading,
  billData,
  payoutBillData,
  onGoBack,
  handleMiscCharge,
  handlePostBill,
  fetchChargeBillSummery,
  chargeSummery,
  allCharges
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [showDeductionDetails, setShowDeductionDetails] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [calculatedEndDate, setCalculatedEndDate] = useState("");
  const [calculatedStartDate, setCalculatedStartDate] = useState("");
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
   const [selectedChargeId, setSelectedChargeId] = useState(null);

  useEffect(() => {
    if (billData || payoutBillData) {
      const startDate = calculateStartDate();
      const endDate = calculateEndDate(startDate);
      setCalculatedStartDate(startDate);
      setCalculatedEndDate(endDate);
    }
  }, [billData, payoutBillData]);
  const getChargeDetailsById = (chargeId) => {
    if (!allCharges || !Array.isArray(allCharges)) return null;
    return allCharges.find(charge => charge.id === chargeId);
  };
  const selectedChargeDetails = getChargeDetailsById(selectedChargeId);

  const getLastDateOfMonth = (dateString) => {
    try {
      if (!dateString || dateString === "N/A" || dateString === "null" || dateString === "undefined") {
        return "N/A";
      }

      let date;
      if (dateString.includes("/")) {
        const [day, month, year] = dateString.split("/").map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateString.includes("-")) {
        date = new Date(dateString);
      } else {
        return "N/A";
      }

      if (isNaN(date.getTime())) {
        return "N/A";
      }

      const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const formattedDay = String(lastDate.getDate()).padStart(2, "0");
      const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
      const formattedYear = lastDate.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    } catch (error) {
      console.error("Error calculating last date of month:", error);
      return "N/A";
    }
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString || dateString === "null" || dateString === "undefined" || dateString === "N/A") {
      return "N/A";
    }

    try {
      let date;
      if (dateString.includes("-")) {
        date = new Date(dateString);
      } else if (dateString.includes("/")) {
        return dateString;
      } else {
        return dateString;
      }

      if (isNaN(date.getTime())) {
        return "N/A";
      }

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };

  const calculateStartDate = () => {
    if (billData?.startDate && billData.startDate !== "null" && billData.startDate !== "undefined" && billData.startDate !== "N/A") {
      return formatDateToDDMMYYYY(billData.startDate);
    }

    return "N/A";
  };

  const calculateEndDate = (startDate) => {
    if (billData?.endDate && billData.endDate !== "null" && billData.endDate !== "undefined" && billData.endDate !== "N/A") {
      return formatDateToDDMMYYYY(billData.endDate);
    }

    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") {
        return monthEndDate;
      }
    }

    return "N/A";
  };

  const getDisplayStartDate = () => {
    if (billData?.startDate) {
      return formatDateToDDMMYYYY(billData.startDate);
    }
    return "N/A";
  };

  const getDisplayEndDate = () => {
    if (billData?.endDate && billData.endDate !== "null" && billData.endDate !== "undefined") {
      return formatDateToDDMMYYYY(billData.endDate);
    }

    const startDate = getDisplayStartDate();
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") {
        return monthEndDate;
      }
    }

    return "N/A";
  };

  const getChargeSummaryEndDate = () => {
    if (chargeSummery?.date) {
      const chargeDate = new Date(chargeSummery.date);
      if (!isNaN(chargeDate.getTime())) {
        const lastDate = new Date(chargeDate.getFullYear(), chargeDate.getMonth() + 1, 0);
        const formattedDay = String(lastDate.getDate()).padStart(2, "0");
        const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
        const formattedYear = lastDate.getFullYear();
        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      }
    }

    return calculatedEndDate;
  };

  if (loading) return <LoadingSpinner />;
  if (!billData) return <div>No bill data available.</div>
  
  console.log("payoutdata", payoutBillData);
  console.log("payouts array:", payoutBillData?.payouts);
  console.log("First item net payable:", payoutBillData?.payouts?.[0]?.netPayable);

  const handleViewClick = (charge) => {
    setSelectedCharge(charge);
    setSelectedChargeId(charge.id);
    setOpenDialog(true);
  };
  
  const totalTransactionalAmount = chargeSummery?.transactionalCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0
  );
  const getChargeName = (chargeType, chargeId) => {
    const chargeDetail = getChargeDetailsById(chargeId);
    return chargeDetail?.name || chargeType || 'N/A';
  };
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    })
      .format(amount)
      .replace("₹", "₹ ");
  };

  const totalFixedAmount = chargeSummery?.fixedCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0
  );

  const totalDeduction = (totalTransactionalAmount || 0) + (totalFixedAmount || 0);

  // Get net payable for the selected day
  const selectedDayNetPayable = selectedDayIndex !== null 
    ? payoutBillData?.payouts?.[selectedDayIndex]?.netPayable || 0 
    : 0;

  // Calculate net deduction using the selected day's net payable
  const netDeduction = totalDeduction + selectedDayNetPayable;

  // Check if the selected day's net payable is negative
  const isNetPayableNegative = selectedDayNetPayable < 0;

  console.log("Calculation:", {
    totalDeduction,
    selectedDayIndex,
    selectedDayNetPayable,
    isNetPayableNegative,
    netDeduction
  });

  const handleDeductionClick = (payoutId, totalDeductions, dayIndex) => {
    console.log("Clicked index:", dayIndex);
    console.log("Net payable from array:", payoutBillData?.payouts?.[dayIndex]?.netPayable);
    
    // Set the selected day index FIRST
    setSelectedDayIndex(dayIndex);
    
    if (totalDeductions >= 0) {
      fetchChargeBillSummery(payoutId);
      setShowDeductionDetails(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, Math.max(0, billData?.charges?.length - 4))
    );
  };

  const visibleCharges =
    billData?.charges?.slice(currentIndex, currentIndex + 4) || [];
  const showArrows = billData?.charges?.length > 4;

  const formatChargeSummaryDate = () => {
    if (chargeSummery?.date) {
      const date = new Date(chargeSummery.date);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      }
    }
    return "N/A";
  };

  return (
    <div className="partner-bill-layout">
      <Sidebar />
      <div className="partner-bill-summary">
        <div style={{ display: "flex", alignItems: "center" }}>
          <button className="back-buttonpayoutDetails" onClick={onGoBack}>
            <img src={leftArrow} alt="" />
          </button>

          <h2 className="partner-title">
            Partner- {billData.name} (Owner ID:{billData.franchiseeId})
          </h2>
        </div>

        <div className="bill-id-banner">
          <div className="bill-id-left">
            Bill ID - <span style={{ fontWeight: 400 }}> {billData.billId}</span>
          </div>
          <div className="bill-id-left">
            {" "}
            Total VM: <span style={{ fontWeight: 400 }}>{payoutBillData?.vmCount || 0}</span>
          </div>
          <div className="bill-id-right">
            <img src={billsummery} alt="" /> Start Date:
            <span style={{ fontWeight: 400 }}>{getDisplayStartDate()} </span> &nbsp; End
            Date:<span style={{ fontWeight: 400 }}>{getDisplayEndDate()}</span>
          </div>
        </div>

        <div className="bill-charges-section">
          <div className="charges-header">
            <h4>Charges Applied on this Bill</h4>
            {billData.status !== "CLOSED" && (
              <Button
                variant="outlined"
                className="add-charge-btn"
                onClick={handleMiscCharge}
              >
                Add Misc. Charge
              </Button>
            )}
          </div>

          <div className="charges-carousel">
            {showArrows && (
              <IconButton
                className="carousel-arrow left-arrow"
                onClick={handlePrev}
                disabled={currentIndex === 0}
              >
                <ChevronLeftIcon />
              </IconButton>
            )}

          
              <div className="charges-container">
                {allCharges?.length > 0 ? (
                  allCharges.map((charge, i) => (
                    <div className="charge-banner" key={i}>
                      {charge.chargeType === "misc_charge" && (
                        <div className="misc-badge">M</div>
                      )}

                      <div className="charge-details">
                        <div className="charge-row">
                          <span className="charge-label">Name:</span>
                          <span className="charge-value" title={getChargeName(charge.chargeType, charge.id)}>
                            {getChargeName(charge.chargeType, charge.id)}
                          </span>
                        </div>
                        <div className="charge-row">
                          <span className="charge-label">Value:</span>
                          <span className="charge-value">{formatCurrency(charge.value)}</span>
                        </div>
                      </div>

                      <IconButton
                        className="chargeview-icon"
                        onClick={() => handleViewClick(charge)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    No charges applied on this bill
                  </div>
                )}
              </div>

            {showArrows && (
              <IconButton
                className="carousel-arrow right-arrow"
                onClick={handleNext}
                disabled={currentIndex >= billData?.charges?.length - 4}
              >
                <ChevronRightIcon />
              </IconButton>
            )}
          </div>
        </div>

     <Dialog
          open={openDialog}
          className="charge-dialog"
          PaperProps={{
            style: {
              borderRadius: '12px',
              padding: '20px',
              minWidth: '450px',
              maxWidth: '600px'
            }
          }}
        >
          <DialogTitle className="dialog-title" sx={{ 
            display: "flex", 
            justifyContent: "flex-start", 
            alignItems: "center", 
            gap: "12px",
            padding: '16px 24px'
          }}>
            <img src={chargeicon} alt="Charge Icon" />
            <div>
              <Typography variant="h5" style={{ fontWeight: 600, fontSize: '20px' }}>
                {selectedChargeDetails?.name || selectedCharge?.chargeType || 'Charge Details'}
              </Typography>
              <Typography variant="subtitle2" style={{ color: '#666', marginTop: '4px' }}>
                Charge ID: {selectedChargeDetails?.id || selectedCharge?.id}
              </Typography>
            </div>
          </DialogTitle>
          
          <DialogContent className="dialog-content" sx={{ padding: '16px 24px' }}>
            <div style={{ display: 'flex',flexDirection:"column"}}>
              <div className="charge-detail-item">
                <span className="detail-label">Charge Type:</span>
                <span className="detail-value" style={{ textTransform: 'capitalize' }}>
                  {selectedChargeDetails?.chargeType || selectedCharge?.chargeType || 'N/A'}
                </span>
              </div>
              
              <div className="charge-detail-item">
                <span className="detail-label">Deduction Type ID:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.deductionTypeId || 'N/A'}
                </span>
              </div>

              <div className="charge-detail-item" style={{ gridColumn: 'span 2' }}>
                <span className="detail-label">Description:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.description || 'No description available'}
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Value Type:</span>
                <span className="detail-value" style={{ textTransform: 'capitalize' }}>
                  {(selectedChargeDetails?.valueType || "N/A")}
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Value Amount:</span>
                <span className="detail-value" style={{ fontWeight: 600 }}>
                  {selectedChargeDetails?.value ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.value}` : 
                      formatCurrency(selectedChargeDetails.value)
                    ) : formatCurrency(selectedCharge?.amount)
                  }
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Minimum Value:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.valueMin ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.valueMin}` : 
                      formatCurrency(selectedChargeDetails.valueMin)
                    ) : 'Not Set'
                  }
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Maximum Value:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.valueMax ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.valueMax}` : 
                      formatCurrency(selectedChargeDetails.valueMax)
                    ) : 'Not Set'
                  }
                </span>
              </div>
            </div>
          </DialogContent>
          
          <DialogActions style={{ justifyContent: 'center', padding: '20px 24px' }}>
            <Button
              onClick={handleCloseDialog}
              variant="contained"
              style={{
                backgroundColor: '#14AE78',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 32px',
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showDeductionDetails}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              maxHeight: "90vh",
              overflow: "hidden",
            }
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px 0" }}>
            <DialogTitle style={{ padding: 0 }}>
              {formatChargeSummaryDate()}
              {chargeSummery?.payoutId ? ` (Payout ID ${chargeSummery.payoutId})` : ""}
            </DialogTitle>
            <IconButton
              onClick={() => setShowDeductionDetails(false)}
              style={{ padding: 8 }}
            >
              <img src={cancel} alt="Close" style={{ width: 24, height: 24 }} />
            </IconButton>
          </div>

          <DialogContent style={{ padding: "0 24px 24px", overflowY: "auto", maxHeight: "calc(90vh - 100px)" }}>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <div
                  style={{
                    border: "2px dashed yellow",
                    padding: "20px",
                    borderRadius: "8px",
                    backgroundColor: "#fffdf0",
                  }}
                >
                  <div style={{ marginBottom: "20px", fontSize: "14px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>
                        <strong>Partner Name</strong> –{" "}
                        {chargeSummery?.name || "N/A"} ({chargeSummery?.type})
                        <br />
                        <strong>Cohort ID</strong> –{" "}
                        {chargeSummery?.cohortId || "N/A"}
                      </div>
                      <div>
                        <strong>Partner Id</strong> –{" "}
                        {chargeSummery?.franchiseeId || "N/A"}
                        <br />
                        <strong>Total VM</strong> – {chargeSummery?.vmCount || "N/A"}
                      </div>
                    </div>
                  </div>

                  <h4 style={{ margin: "16px 0 8px", fontSize: "14px" }}>
                    Charge Summary (Transactional)
                  </h4>
                  <TableContainer
                    component={Paper}
                    style={{
                      marginBottom: "20px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "150px",
                      overflowY: "auto"
                    }}
                  >
                    <Table size="small" style={{ border: "none" }}>
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5", position: "sticky", top: 0, zIndex: 1 }}>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "20%" }}
                          >
                            Deduction ID
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "50%" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "30%" }}
                          >
                            Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chargeSummery?.transactionalCharges?.map((charge) => (
                          <TableRow
                            key={`transactional-${charge.id}`}
                            style={{ border: "none" }}
                          >
                            <TableCell style={{ border: "none" }}>{charge.id}</TableCell>
                            <TableCell style={{ border: "none" }}>
                              {charge.chargeType === "raas_fee"
                                ? "RAAS Fee(%)"
                                : charge.chargeType === "ps_fee"
                                ? "PS Fee(%)"
                                : charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: "none" }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                            borderTop: "1px solid #ccc",
                          }}
                        >
                          <TableCell colSpan={2} style={{ border: "none" }}>
                            % Charge Total
                          </TableCell>
                          <TableCell align="right" style={{ border: "none" }}>
                            {formatCurrency(totalTransactionalAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <h4 style={{ margin: "16px 0 8px", fontSize: "14px" }}>
                    Charge Summary (Fixed)
                  </h4>
                  <TableContainer
                    component={Paper}
                    style={{
                      marginBottom: "20px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "150px",
                      overflowY: "auto"
                    }}
                  >
                    <Table size="small" style={{ border: "none" }}>
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5", position: "sticky", top: 0, zIndex: 1 }}>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "20%" }}
                          >
                            Deduction ID
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "50%" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", border: "none", textAlign: "center", width: "30%" }}
                          >
                            Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chargeSummery?.fixedCharges?.map((charge) => (
                          <TableRow key={`fixed-${charge.id}`} style={{ border: "none" }}>
                            <TableCell style={{ border: "none" }}>{charge.id}</TableCell>
                            <TableCell style={{ border: "none" }}>
                              {charge.chargeType === "saas_ik"
                                ? "SAAS IK"
                                : charge.chargeType === "rental_ik"
                                ? "Rental IK"
                                : charge.chargeType === "misc_charge"
                                ? "Miscellaneous"
                                : charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: "none" }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                            borderTop: "1px solid #ccc",
                          }}
                        >
                          <TableCell colSpan={2} style={{ border: "none" }}>
                            Fix Charge Total
                          </TableCell>
                          <TableCell align="right" style={{ border: "none" }}>
                            {formatCurrency(totalFixedAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <div
                    style={{
                      marginTop: "20px",
                      fontWeight: "bold",
                      fontSize: "14px",
                      textAlign: "left",
                      backgroundColor: "#D9D9D980",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                    }}
                  >
                    Total Deduction (Transactional + Fixed) ={" "}
                    {formatCurrency(
                      (chargeSummery?.totalTransactionalDeductions || 0) +
                      (chargeSummery?.totalFixedDeductions || 0)
                    )}
                  </div>

                  {/* NET DEDUCTION SECTION - ONLY SHOW WHEN THE SELECTED DAY'S NET PAYABLE IS NEGATIVE */}
                  {isNetPayableNegative && (
                    <div
                      style={{
                        marginTop: "20px",
                        fontWeight: "bold",
                        fontSize: "14px",
                        textAlign: "left",
                        backgroundColor: "#D9D9D980",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "10px",
                      }}
                    >
                      Net Deduction (Total Deduction + Net Payout) ={" "}
                      {formatCurrency(netDeduction)}
                      <span style={{ marginLeft: "10px", fontSize: "12px", color: "#666" }}>
                        (Net Payout:{formatCurrency(selectedDayNetPayable)})
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}
          </DialogContent>
        </Dialog>

        <div className="summary-section">
          <div className="summary-header">
            <h4>
              📅 Bill Summary -{" "}
              <span style={{ fontSize: "14px" }}>{payoutBillData?.startDate}</span>{" "}
              <span style={{ fontSize: "14px" }}>to</span>{" "}
              <span style={{ fontSize: "14px" }}>{payoutBillData?.endDate}</span>
              <span
                className={`status-badgepayout ${billData.status?.toLowerCase()}`}
              >
                {" "}
                {billData.status}{" "}
              </span>
            </h4>
            <a className="past-bills-link" onClick={handlePostBill}>
              View Past Bills
            </a>
          </div>
          <div className="summary-cards">
            <div className="summary-card">
              <div>Total Gross Sale</div>
              <strong>{payoutBillData?.totalGrossSale || 0}</strong>
            </div>
            <div className="summary-card">
              <div>Total Fix Deduction</div>
              <strong>{payoutBillData?.totalFixedDeductions || 0}</strong>
            </div>
            <div className="summary-card">
              <div>Total Transactional Deduction</div>
              <strong>{payoutBillData?.totalTransactionalDeductions || 0}</strong>
            </div>
            <div className="summary-card">
              <div>Net Payout</div>
              <strong>{payoutBillData?.totalNetPayable || 0}</strong>
            </div>
          </div>
        </div>

        <div className="table-section">
          <h4>📊 Day Wise Payout Details</h4>
          <div className="table-wrapper-details">
            <table className="payout-table">
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Settlement ID</th>
                  <th>Total Gross Sale</th>
                  <th>Net Payout</th>
                  <th>Total Deduction</th>
                </tr>
              </thead>
              <tbody>
                {payoutBillData &&
                  payoutBillData?.payouts?.map((day, i) => (
                    <tr key={i}>
                      <td>{day.date}</td>
                      <td>{day.payoutId}</td>
                      <td>{day.revenueToday}</td>
                      <td>{day.netPayable}</td>
                      <td>
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleDeductionClick(
                              day.payoutId,
                              day.netPayable < 0
                                ? day.revenueToday    
                                : day.totalDeductions, 
                              i
                            );
                          }}
                        >
                          {day.netPayable < 0
                            ? day.revenueToday       
                            : day.totalDeductions}   
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerBillDetailsComponent;